import geocode from "react-geocode";
import config from "config";
import { preferredLang } from "utils/localizer";

// setup library
geocode.setApiKey(config.geocode.apiKey);
geocode.setLanguage(preferredLang);

// lat & long from address
export const getCoordinatesByAddress = async (address: string) => { // eslint-disable-line
    const response = await geocode.fromAddress(address);
    const { lat: latitude, lng: longitude } = response.results[0].geometry.location as { lat: number, lng: number };
    return { latitude, longitude };
};
